export type PropagateToWorkersField =
  | 'actualMiddlewareFile'
  | 'actualInstrumentationHookFile'
  | 'loadEnvConfig'
  | 'appPathRoutes'
  | 'middleware'
  | 'renderOpts'
